<div class="edit-page">

  <div class="edit-header">
    <button mat-icon-button (click)="goBack()" matTooltip="Volver" class="edit-back-btn">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <mat-icon class="edit-header-icon">account_tree</mat-icon>
    <div class="edit-header-text">
      <h2 class="edit-title">{{ unitName }}</h2>
      <p class="edit-subtitle" *ngIf="isNewUnit">Alta de unidad</p>
      <p class="edit-subtitle" *ngIf="!isNewUnit">Edici&oacute;n de unidad</p>
    </div>
  </div>

  <mat-card class="edit-card" *ngIf="isLoading || errorMessage; else formContent">
    <mat-card-content>
      <div *ngIf="isLoading" class="loading-state">
        <mat-spinner></mat-spinner>
        <p>Cargando datos de la unidad...</p>
      </div>

      <div *ngIf="errorMessage && !isLoading" class="error-container">
        <mat-icon color="warn">error</mat-icon>
        <p>{{ errorMessage }}</p>
      </div>
    </mat-card-content>
  </mat-card>

  <ng-template #formContent>
    <form [formGroup]="unitForm">

      <mat-accordion>
            <!-- Datos Basicos -->
            <mat-expansion-panel #basicPanel [expanded]="!isEditingAddress">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>info</mat-icon>
                  <span>Datos B&aacute;sicos</span>
                  <mat-icon class="status-icon accent" *ngIf="isBasicSectionValid">check_circle</mat-icon>
                  <mat-icon class="status-icon warn" *ngIf="!isBasicSectionValid && isBasicSectionTouched">error</mat-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-container">
                <mat-form-field class="form-field full-width">
                  <mat-label>Nombre</mat-label>
                  <input matInput formControlName="name" placeholder="Ingrese el nombre de la unidad" />
                  <mat-error *ngIf="unitForm.get('name')?.hasError('required')">
                    El nombre es requerido
                  </mat-error>
                  <mat-error *ngIf="unitForm.get('name')?.hasError('minlength')">
                    El nombre debe tener al menos 3 caracteres
                  </mat-error>
                  <mat-error *ngIf="unitForm.get('name')?.hasError('maxlength')">
                    El nombre no puede exceder 200 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Nombre Corto</mat-label>
                  <input matInput formControlName="shortName" placeholder="Ingrese el nombre corto" />
                  <mat-error *ngIf="unitForm.get('shortName')?.hasError('required')">
                    El nombre corto es requerido
                  </mat-error>
                  <mat-error *ngIf="unitForm.get('shortName')?.hasError('minlength')">
                    El nombre corto debe tener al menos 1 car&aacute;cter
                  </mat-error>
                  <mat-error *ngIf="unitForm.get('shortName')?.hasError('maxlength')">
                    El nombre corto no puede exceder 50 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Centro de Costos</mat-label>
                  <input matInput formControlName="costCentre" placeholder="Ingrese el centro de costos" />
                  <mat-error *ngIf="unitForm.get('code')?.hasError('maxlength')">
                    El centro de costos no puede exceder 100 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Nivel Organizacional</mat-label>
                  <mat-select formControlName="organizationLevelId" placeholder="Seleccione el nivel">
                    <mat-option *ngFor="let level of levelOptions" [value]="level.id">
                      {{ level.label }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="unitForm.get('organizationLevelId')?.hasError('required')">
                    El nivel organizacional es requerido
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width" *ngIf="requiresParent">
                  <mat-label>Unidad Superior</mat-label>
                  <input matInput
                         #parentAutoTrigger="matAutocompleteTrigger"
                         formControlName="parentUnitSearch"
                         [matAutocomplete]="parentAuto"
                         placeholder="Seleccione o busque la unidad superior..."
                         (focus)="onParentUnitInputFocus()" />
                  <mat-spinner matSuffix *ngIf="isSearchingParent" diameter="18"></mat-spinner>
                  <mat-autocomplete #parentAuto="matAutocomplete" (optionSelected)="onParentUnitSelected($event.option.value)">
                    <mat-optgroup *ngFor="let group of parentUnitGroups" [label]="group.levelLabel">
                      <mat-option *ngFor="let unit of group.units" [value]="unit">
                        {{ unit.name }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-autocomplete>
                  <mat-error *ngIf="unitForm.get('parentUnitSearch')?.touched && !unitForm.get('parentUnitId')?.value">
                    Debe seleccionar la unidad superior
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Descripci&oacute;n</mat-label>
                  <textarea matInput formControlName="description" placeholder="Ingrese una descripci&oacute;n" rows="3"></textarea>
                  <mat-error *ngIf="unitForm.get('description')?.hasError('maxlength')">
                    La descripci&oacute;n no puede exceder 500 caracteres
                  </mat-error>
                </mat-form-field>
              </div>

            </mat-expansion-panel>

            <mat-expansion-panel #buildingPanel *ngIf="isCommunityLevel" [expanded]="isEditingAddress">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>location_on</mat-icon>
                  <span>Datos Edilicios</span>
                  <mat-icon class="status-icon accent" *ngIf="isBuildingSectionValid">check_circle</mat-icon>
                  <mat-icon class="status-icon warn" *ngIf="!isBuildingSectionValid && isBuildingSectionTouched">error</mat-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="form-container">
                <mat-form-field class="form-field full-width">
                  <mat-label>Direcci&oacute;n</mat-label>
                  <input matInput formControlName="addressLine" placeholder="Ingrese la direcci&oacute;n" />
                  <mat-error *ngIf="unitForm.get('addressLine')?.hasError('maxlength')">
                    La direcci&oacute;n no puede exceder 200 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Ciudad</mat-label>
                  <input matInput formControlName="city" placeholder="Ingrese la ciudad" />
                  <mat-error *ngIf="unitForm.get('city')?.hasError('maxlength')">
                    La ciudad no puede exceder 100 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Departamento</mat-label>
                  <input matInput formControlName="department" placeholder="Ingrese el departamento" />
                  <mat-error *ngIf="unitForm.get('department')?.hasError('maxlength')">
                    El departamento no puede exceder 100 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Provincia</mat-label>
                  <input matInput formControlName="province" placeholder="Ingrese la provincia" />
                  <mat-error *ngIf="unitForm.get('province')?.hasError('maxlength')">
                    La provincia no puede exceder 100 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Pa&iacute;s</mat-label>
                  <input
                    matInput
                    [matAutocomplete]="countryAutocomplete"
                    (input)="filterCountries($event.target.value)"
                    [value]="selectedCountry?.name || ''"
                    placeholder="Busque por nombre, c&oacute;digo ISO2 o ISO3" />
                  <input formControlName="countryId" style="display:none;" />
                  <mat-autocomplete #countryAutocomplete="matAutocomplete">
                    <mat-optgroup label="Pa&iacute;ses disponibles">
                      <mat-option
                        *ngFor="let country of filteredCountries"
                        (onSelectionChange)="onCountrySelected(country.id)">
                        {{ country.name }} ({{ country.iso2Code }})
                      </mat-option>
                    </mat-optgroup>
                    <mat-optgroup *ngIf="filteredCountries.length === 0" label="Sin resultados">
                      <mat-option disabled>
                        No se encontraron pa&iacute;ses
                      </mat-option>
                    </mat-optgroup>
                  </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>C&oacute;digo Postal</mat-label>
                  <input matInput formControlName="postalCode" placeholder="Ingrese el c&oacute;digo postal" />
                  <mat-error *ngIf="unitForm.get('postalCode')?.hasError('maxlength')">
                    El c&oacute;digo postal no puede exceder 20 caracteres
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Latitud</mat-label>
                  <input matInput formControlName="latitude" placeholder="Ingrese la latitud (-90 a 90)" />
                  <mat-error *ngIf="unitForm.get('latitude')?.hasError('pattern')">
                    La latitud debe ser un n&uacute;mero v&aacute;lido
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Longitud</mat-label>
                  <input matInput formControlName="longitude" placeholder="Ingrese la longitud (-180 a 180)" />
                  <mat-error *ngIf="unitForm.get('longitude')?.hasError('pattern')">
                    La longitud debe ser un n&uacute;mero v&aacute;lido
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="form-field full-width">
                  <mat-label>Informaci&oacute;n Adicional</mat-label>
                  <textarea matInput formControlName="additionalInfo" placeholder="Ingrese informaci&oacute;n adicional" rows="3"></textarea>
                  <mat-error *ngIf="unitForm.get('additionalInfo')?.hasError('maxlength')">
                    La informaci&oacute;n adicional no puede exceder 1000 caracteres
                  </mat-error>
                </mat-form-field>
              </div>

            </mat-expansion-panel>

      </mat-accordion>

    </form>
  </ng-template>

  <div class="edit-footer" *ngIf="!isLoading && !errorMessage">
    <button mat-raised-button (click)="cancel()" [disabled]="isSaving">
      <mat-icon>cancel</mat-icon>
      Cancelar
    </button>
    <button *ngIf="canManageCommunityData" mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
      <mat-spinner *ngIf="isSaving" diameter="20" class="button-spinner"></mat-spinner>
      <mat-icon *ngIf="!isSaving">save</mat-icon>
      {{ isSaving ? 'Guardando...' : 'Guardar' }}
    </button>
  </div>

</div>
